function isIOSUserAgent() {
  return typeof window !== 'undefined'
  && typeof window.navigator !== 'undefined'
  && (/iPad|iPhone|iPod/.test(window.navigator.userAgent || ''));
}

module.exports = {
  isIOSUserAgent,
};
